import React from 'react';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

type Props = Omit<SvgIconProps, 'viewBox'>;

export function WarningIcon(props: Props) {
    const newProps = {
        width: 24,
        height: 24,
        fill: 'none',
        'aria-hidden': true,
        ...props,
        viewBox: '0 0 24 24',
    };
    return React.createElement(
        SvgIcon,
        newProps,
        <path
            d="M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.7a2.41 2.41 0 0 0-3.41 0Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />,
        <line
            x1="12"
            y1="9"
            x2="12"
            y2="13"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
        />,
        <line
            x1="12"
            y1="17"
            x2="12.01"
            y2="17"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
        />
    );
}
